import { render, staticRenderFns } from "./StaticFrame.vue?vue&type=template&id=17eca1f2&scoped=true&"
import script from "./StaticFrame.vue?vue&type=script&lang=js&"
export * from "./StaticFrame.vue?vue&type=script&lang=js&"
import style0 from "./StaticFrame.vue?vue&type=style&index=0&id=17eca1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eca1f2",
  null
  
)

export default component.exports